module.exports = __webpack_public_path__ + "static/media/barcode-read.41baae7c.svg";